'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardDepartmentsCtrl', ['departments','clients', '$uibModal','$state','dialog','$translate','Department', 'Authentication', require('./dashboardDepartmentsCtrl')]);
app.config(['$stateProvider', require('./dashboardDepartmentsConfig')]);
